var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { AvatarLetter, AvatarList, Loader, TableBodyCell, Tooltip, Typography, } from '@pocketlaw/tetris';
import { GetUsersDocument } from './users.gql';
import { PopoverContentContainer } from './styled';
export function ContractOwnerCell(props) {
    const { userIds = [] } = props, rest = __rest(props, ["userIds"]);
    const { data, loading } = useQuery(GetUsersDocument, {
        variables: {
            ids: userIds,
        },
        skip: !(userIds === null || userIds === void 0 ? void 0 : userIds.length),
    });
    const { users = [] } = data || {};
    if (loading) {
        return (<TableBodyCell {...rest}>
        <Loader />
      </TableBodyCell>);
    }
    if (!users.length) {
        return <TableBodyCell {...rest}>&nbsp;</TableBodyCell>;
    }
    return (<TableBodyCell {...rest}>
      <Tooltip title={<PopoverContentContainer>
            {users.map(user => (<Typography key={user.id} $appearance="light">
                {user.name}
              </Typography>))}
          </PopoverContentContainer>}>
        <div>
          <AvatarList size="sm" avatars={users.map(user => ({
            id: user.id,
            component: user.name && <AvatarLetter>{user.name[0]}</AvatarLetter>,
        }))}/>
        </div>
      </Tooltip>
    </TableBodyCell>);
}
